import React, { Component } from "react";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
// import "bootstrap/dist/css/bootstrap.css";
import MessengerData from "../../components/messangerPlugin";
import Fade from "react-reveal/Fade";
import LoaderScreen from "../../components/Loader/loader";
import firebase from "../../config/firebase";
var db = firebase.database();
class Books extends Component {
  constructor(props) {
    super(props);
    this.state = { arr: [], pageloader: false };
  }
  componentDidMount() {
    this.getData();
  }
  getData = () => {
    this.setState({ pageloader: true });
    db.ref("VideoLink").on("value", (snapshot) => {
      var newArr = [];
      snapshot.forEach((data) => {
        var childData = data.val();
        console.log("childData", childData);
        newArr.push(childData);
      });
      this.setState({ arr: newArr.reverse(), pageloader: false });
    });
  };
  render() {
    return (
      <div
      // class=" d-flex flex-row align-items-center"
      // style={{ background: " #dedede ", minHeight: "100vh" }}
      >
        <Navigations />
        {this.state.pageloader === true ? (
          <LoaderScreen />
        ) : (
          <Fade>
            <div>
              <div
                style={{
                  borderBottom: "3px solid black",
                  textAlign: "center",
                  marginTop: "5rem",
                }}
              >
                <h1 style={{ color: "rgb(118, 102, 223)" }}>
                  My Youtube Videos
                </h1>
                <h4 style={{ color: "rgb(118, 102, 223)" }}>
                  I’ve been designed videos for my projects.
                </h4>
              </div>
              <div class="container-fluid">
                <div class="row">
                  {this.state.arr.map((e, i) => {
                    return (
                      <div class="col-sm-12 col-md-4 mt-4 mb-4">
                        <div class="embed-responsive embed-responsive-16by9">
                          <iframe
                            class="embed-responsive-item"
                            src={`https://www.youtube.com/embed/${e.VideoId}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded youtube"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <Footer />
            </div>
          </Fade>
        )}
        <MessengerData />
      </div>
    );
  }
}

export default Books;
